module.exports = __webpack_public_path__ + "static/img/icon-mypage-2.e6cabb0.png";